import { ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit';
import { CartItem, CartState } from '../general/cartTypes';

export const updateClientCartAltItem = createAction<CartItem[]>('clientCart/updateAltItems');

export const addUpdateClientCartAltItemCases = (builder: ActionReducerMapBuilder<CartState>) =>
  builder.addCase(updateClientCartAltItem, (state, action) => {
    state.cart = action.payload;
  });
